import React from 'react';
import PropTypes from 'prop-types';

const FootfallRepeatVsUnique = props => (
  <div>
    { props.clientId === '5ff8d2b86811f3057a4dc9cb' ?(
      <div style={{display: 'flex',alignItems:' center', justifyContent: 'center',minHeight: '300px'}}>

        <div>Insights coming soon</div>

      </div>
    ) :(
      <div className="TravellingPastUniqueVsRepeat">
      <div className="TravellingPastUniqueVsRepeat_section">
        <span className="TravellingPastUniqueVsRepeat_percentage">
          {Number.isNaN(props.repeatPercent)
            ? 0
            : Math.round(props.repeatPercent)}
          %
        </span>
        <span className="TravellingPastUniqueVsRepeat_title">
          {props.accountType === 'intelligence'
            ? `the percentage of devices that travel past the selected Point(s) of Interest more than once`
            : props.insightType === 'organisation'
            ? `of devices have repeatedly visited ${props.organisationLabel}`
            : `of devices have repeatedly visited ${props.subcategoryLabel}`}
        </span>
      </div>
      <div className="TravellingPastUniqueVsRepeat_section">
        <span className="TravellingPastUniqueVsRepeat_percentage">
          {Number.isNaN(props.uniquePercent)
            ? 0
            : Math.round(props.uniquePercent)}
          %
        </span>
        <span className="TravellingPastUniqueVsRepeat_title">
          {props.accountType === 'intelligence'
            ? `the percentage of devices that travel past the selected Point(s) of Interest only once`
            : props.insightType === 'organisation'
            ? `of devices have only visited ${props.organisationLabel} once`
            : `of devices have only visited ${props.subcategoryLabel} once`}
        </span>
      </div>
    </div>
    )}


    { (props.clientId === '5e65c56daea1a93aa7211595' || props.clientId ===  '5ff8d2b86811f3057a4dc9cb') ? (
      <div />
    ) : (
      <React.Fragment>
        <h3 className="content-card_title">
          {props.accountType === 'intelligence' ? `Age & Gender` : `Frequency`}
        </h3>
        <div className="TravellingPastUniqueVsRepeat">
          <div className="TravellingPastUniqueVsRepeat_frequency">
            {props.accountType === 'intelligence' ? (
              ``
            ) : (
              <span className="TravellingPastUniqueVsRepeat_percentage">
                {Number.isNaN(props.averageEventsByPOI)
                  ? `0x`
                  : `${props.averageEventsByPOI.toFixed(1)}x`}
              </span>
            )}

            <span className="TravellingPastUniqueVsRepeat_title">
              {props.accountType === 'intelligence'
                ? `Insights coming soon`
                : props.insightType === 'organisation'
                ? `is the average number of times a device has visited ${
                    props.organisationLabel
                  }`
                : `is the average number of times a device has visited ${
                    props.subcategoryLabel
                  }`}
            </span>
          </div>
        </div>
      </React.Fragment>
    )}
  </div>
);

FootfallRepeatVsUnique.propTypes = {
  repeatPercent: PropTypes.number,
  uniquePercent: PropTypes.number,
  averageEvents: PropTypes.number,
  averageEventsByPOI: PropTypes.number,
};

FootfallRepeatVsUnique.defaultProps = {
  repeatPercent: undefined,
  uniquePercent: undefined,
  averageEvents: undefined,
  averageEventsByPOI: 0,
};

export default FootfallRepeatVsUnique;
